import React from 'react';
import PropTypes from 'prop-types';
import ChatbotV2 from './Chatbot';
import { FPTI_DATA } from '../../common/propTypes';

const defaultDisplay = true;

const ChatbotAssistant = function (props) {
  const {
    link,
    display = defaultDisplay,
    topicRefId,
    chatBotClicked,
    chatPillOcpParams,
    isChatBotAsyncUser,
    topicName,
    FPTIData,
  } = props;

  const CHATBOT_SESSIONTYPE = 'chatBot';

  return (
    <ChatbotV2
      link={link}
      id={CHATBOT_SESSIONTYPE}
      display={display}
      topicRefId={topicRefId}
      topicName={topicName}
      chatBotClicked={chatBotClicked}
      chatPillOcpParams={chatPillOcpParams}
      isChatBotAsyncUser={isChatBotAsyncUser}
      FPTIData={FPTIData}
    />
  );
};

ChatbotAssistant.propTypes = {
  link: PropTypes.string.isRequired,
  display: PropTypes.bool.isRequired,
  chatBotClicked: PropTypes.func,
  topicRefId: PropTypes.string,
  topicName: PropTypes.string,
  isChatBotAsyncUser: PropTypes.bool.isRequired,
  chatPillOcpParams: PropTypes.string,
  FPTIData: PropTypes.shape(FPTI_DATA),
};

export default ChatbotAssistant;
